// extracted by mini-css-extract-plugin
module.exports = {"Section_Header":"Section-module--Section_Header--2JRuT","Section_BackwardIcon":"Section-module--Section_BackwardIcon--3AbkG"};